
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetolavasacabservice() {



    const cardData =
    {
        keyword: 'Pune to Lavasa Cab Service',
        heading: 'Platinum24 Cabs: Pune to Lavasa Cab Service',
        headingDescription: ' Platinum24 Cabs offers comfortable Pune to Lavasa Cab Service, perfect for family outings, weekend getaways, and corporate trips to the scenic hill city. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a smooth and safe ride through the winding Western Ghat roads. With professional chauffeurs, punctual pickups, and transparent fares, we make your Pune to Lavasa journey completely hassle-free. Whether you’re planning sightseeing, leisure stays, or business retreats, Platinum24 Cabs provides affordable one-way and round-trip options for a reliable and enjoyable travel experience to Lavasa.',

        top: 'Top Places to Visit in Lavasa with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Lavasa Lake Promenade",
    "description": "The Lavasa Lake Promenade is the heart of the hill city, offering stunning views of Warasgaon Lake. Colorful buildings along the waterfront create a European-style charm. Tourists enjoy evening walks, cycling, and lakeside dining. Cafés and restaurants line the promenade, making it vibrant and lively. The calm waters reflect sunsets beautifully. It is Lavasa’s most photographed and iconic spot."
  },
  {
    "title": "Warasgaon Lake",
    "description": "Warasgaon Lake surrounds Lavasa and offers activities like boating, kayaking, and jet skiing. The lake’s serene waters and green hills make it ideal for relaxation. Adventure lovers enjoy water sports while families prefer peaceful boat rides. Misty monsoons enhance the beauty of the lake. Photographers capture its reflections and scenic charm. Warasgaon Lake is Lavasa’s natural jewel."
  },
  {
    "title": "Temghar Dam",
    "description": "Temghar Dam, located on the Mutha River, is a popular stop en route to Lavasa. The dam provides water supply and creates picturesque landscapes. In monsoon, the overflowing dam is a spectacular sight. Street vendors selling hot corn and tea add to the charm. Tourists enjoy photography and picnics here. Temghar Dam is Lavasa’s gateway of scenic beauty."
  },
  {
    "title": "Nature Trails and Trekking",
    "description": "Lavasa is surrounded by the Sahyadri hills, offering trekking trails and nature walks. Treks lead to waterfalls, forests, and viewpoints. Adventure seekers enjoy hiking in monsoon when hills turn lush green. Guided tours are available for birdwatching and jungle exploration. Trails are safe and suitable for families too. Lavasa’s trails are a blend of adventure and nature."
  },
  {
    "title": "Bamboosa",
    "description": "Bamboosa is Lavasa’s cultural and craft village that showcases bamboo art and furniture. It provides insights into sustainable living and eco-friendly products. Tourists can watch artisans at work and shop for unique souvenirs. Workshops are conducted to promote traditional skills. The village also has a café for relaxation. Bamboosa is Lavasa’s hub of art, culture, and sustainability."
  },
  {
    "title": "Dasve Viewpoint",
    "description": "Dasve Viewpoint offers panoramic views of Lavasa city, Warasgaon Lake, and surrounding valleys. The viewpoint is easily accessible and a must-visit for photographers. Sunrise and sunset from here are breathtaking. Monsoon clouds and mist make it magical. Couples and families love spending time here. Dasve Viewpoint is Lavasa’s top scenic spot."
  },
  {
    "title": "Adventure Sports",
    "description": "Lavasa is known for adventure sports including ziplining, rappelling, and rock climbing. Water-based activities like kayaking and pedal boating add thrill. Corporate groups and families enjoy team-building adventure packages. Professional instructors ensure safety. These activities make Lavasa a favorite for weekend adventure trips. It is Maharashtra’s modern adventure hub."
  },
  {
    "title": "Temghar-Lavasa Ghat Road",
    "description": "The Temghar-Lavasa Ghat Road itself is a major attraction with winding curves and breathtaking views. Road trippers enjoy driving through misty hills and valleys, especially in monsoon. Waterfalls along the route add to the charm. Bikers and photographers love this journey. Every turn reveals a new scenic vista. The ghat road is Lavasa’s thrilling approach."
  },
  {
    "title": "Town Hall and Convention Center",
    "description": "Lavasa’s Town Hall and Convention Center host cultural events, exhibitions, and corporate conferences. The modern architecture blends with the hill city’s design. Events here range from music festivals to art exhibitions. Tourists visiting during events experience Lavasa’s vibrant side. It also promotes business tourism. The Town Hall is Lavasa’s hub of events and gatherings."
  },
  {
    "title": "Luxury Resorts & Spas",
    "description": "Lavasa is dotted with luxury resorts and wellness spas offering lake-view stays. Resorts provide activities like cycling, bonfires, and nature walks. Spas specialize in Ayurvedic and modern therapies for relaxation. Couples prefer Lavasa for romantic getaways. Families enjoy poolside leisure and kids’ activities. Resorts make Lavasa Maharashtra’s premium holiday destination."
  }
],



  "services": [
    {
      "name": "Pune to Lavasa Taxi",
      "description": "Experience a hassle-free and comfortable journey from Pune to the serene hill station of Lavasa with our dedicated taxi services. Whether it’s a weekend getaway, family trip, or corporate outing, our Pune to Lavasa Taxi offers privacy, flexibility, and convenience to make your travel memorable."
    },
    {
      "name": "Lavasa Cab from Pune",
      "description": "Our Lavasa Cab service from Pune features well-maintained vehicles driven by experienced drivers who ensure safe and timely transfers. Enjoy scenic routes through the Western Ghats, making your journey as delightful as your destination."
    },
    {
      "name": "Pune Lavasa Taxi Booking",
      "description": "Easily book your Pune to Lavasa taxi online or via phone, choosing from a wide range of cars to suit your group size and budget. We offer instant confirmation and 24x7 booking support for your convenience."
    },
    {
      "name": "Taxi Service Pune to Lavasa",
      "description": "Our Taxi Service from Pune to Lavasa is designed for reliability and comfort, with options for one-way trips, round trips, and multi-day packages, tailored to your travel needs."
    },
    {
      "name": "Lavasa Cab Rental Pune",
      "description": "Rent a cab to explore Lavasa at your own pace with flexible rental hours. Our cab rental service allows sightseeing and local travel within Lavasa with affordable rates and professional drivers."
    },
    {
      "name": "Pune to Lavasa Taxi Fare",
      "description": "Benefit from competitive and transparent pricing on all Pune to Lavasa taxi fares. We offer no hidden charges and special packages to fit your budget, making quality travel affordable."
    },
    {
      "name": "Pune Lavasa Private Taxi",
      "description": "Book a private taxi for exclusive use, perfect for families, couples, and corporate groups seeking privacy and a personalized travel experience."
    },
    {
      "name": "Lavasa Cab Packages Pune",
      "description": "Choose from various cab packages that include sightseeing tours, airport transfers, and customized travel plans around Lavasa and nearby attractions."
    },
    {
      "name": "Lavasa Cab for Weekend Trips Pune",
      "description": "Ideal for weekend travelers, our Lavasa Cab packages ensure you can enjoy all the scenic beauty and adventure activities without worrying about transportation logistics."
    },
    {
      "name": "Pune to Lavasa One Way Cab",
      "description": "Opt for our convenient one-way cab services from Pune to Lavasa, perfect for quick trips or drop-offs without the need to book a return ride."
    },
    {
      "name": "Lavasa Taxi with Driver Pune",
      "description": "Travel stress-free with professional drivers who are familiar with the routes and committed to providing a safe, comfortable journey from Pune to Lavasa."
    },
    {
      "name": "Taxi Service Pune to Lavasa",
      "description": "Our 24x7 taxi service from Pune to Lavasa ensures you can book a ride anytime, with timely pickups and reliable vehicles at your disposal."
    }
  ],
  "tableData": [
    ["Pune to Lavasa Taxi", "Lavasa Cab from Pune"],
    ["Pune Lavasa Taxi Booking", "Taxi Service Pune to Lavasa"],
    ["Lavasa Cab Rental Pune", "Pune to Lavasa Taxi Fare"],
    ["Pune Lavasa Private Taxi", "Lavasa Cab Packages Pune"],
    ["Lavasa Cab for Weekend Trips Pune", "Pune to Lavasa One Way Cab"],
    ["Lavasa Taxi with Driver Pune", "Taxi Service Pune to Lavasa"]
  ],


      "whychoose": [
    {
      "WhyChooseheading": "Reliable Pune to Lavasa Cab Service",
      "WhyChoosedescription": "Platinum24 Cabs offers comfortable and timely cab services from Pune to the scenic hill city of Lavasa."
    },
    {
      "WhyChooseheading": "Experienced Drivers Familiar with Pune-Lavasa Routes",
      "WhyChoosedescription": "Our skilled drivers know the best routes to ensure a smooth and safe journey to Lavasa."
    },
    {
      "WhyChooseheading": "Spacious and Well-Maintained Vehicles",
      "WhyChoosedescription": "Travel comfortably in clean, air-conditioned cabs with ample space for passengers and luggage."
    },
    {
      "WhyChooseheading": "Flexible Booking Options for One-Way and Round Trips",
      "WhyChoosedescription": "Choose from customizable packages tailored to your travel plans between Pune and Lavasa."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
      "WhyChoosedescription": "Enjoy upfront pricing that covers fuel, tolls, and driver allowances for a hassle-free experience."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Easy Booking",
      "WhyChoosedescription": "Our dedicated team is available round the clock to assist with bookings and special requests."
    },
    {
      "WhyChooseheading": "Ideal for Family Trips, Group Outings, and Corporate Travel",
      "WhyChoosedescription": "Our Pune to Lavasa cab services cater to all travel needs, whether leisure or business."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options to Suit Your Group Size",
      "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, or tempo travellers for your journey."
    }
  ]




































    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs provide cab services from Pune to Lavasa?',
        answer: 'Yes, Platinum24 Cabs offers reliable and comfortable cab services for travel between Pune and Lavasa.',
    },
    {
        question: 'How can I book a Pune to Lavasa cab with Platinum24 Cabs?',
        answer: 'You can easily book your Pune to Lavasa cab through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Lavasa trips?',
        answer: 'We offer a variety of vehicles including sedans, SUVs, and tempo travellers to suit your travel preferences and group size.',
    },
    {
        question: 'Are the drivers experienced for Pune to Lavasa routes?',
        answer: 'Yes, all our drivers are professional, experienced, and knowledgeable about the Pune to Lavasa route.',
    },
    {
        question: 'Can I book a round trip cab from Pune to Lavasa?',
        answer: 'Absolutely! We provide round-trip cab services with flexible scheduling to accommodate your travel plans.',
    },
    {
        question: 'What is included in the fare for Pune to Lavasa cab services?',
        answer: 'The fare includes vehicle charges, driver allowance, fuel, tolls, and taxes. Additional charges may apply for extra stops or waiting time.',
    },
    {
        question: 'Can I customize pickup and drop-off locations for Pune to Lavasa rides?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points along the Pune-Lavasa route.',
    },
    {
        question: 'Are safety measures followed during Pune to Lavasa cab rides?',
        answer: 'All vehicles are regularly sanitized, and our drivers follow strict safety protocols for your protection.',
    },
    {
        question: 'Is it possible to hire a cab for multiple days for Pune to Lavasa travel?',
        answer: 'Yes, we offer hourly and multi-day rental packages tailored to your travel needs.',
    },
    {
        question: 'Does Platinum24 Cabs provide corporate taxi services from Pune to Lavasa?',
        answer: 'Yes, we offer customized corporate travel solutions including priority support and flexible billing for Pune to Lavasa routes.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Vikram Shah',
        feedback: 'The Pune to Lavasa cab service was excellent. The driver was punctual and the vehicle was very comfortable.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Shruti Kulkarni',
        feedback: 'I had a great experience traveling from Pune to Lavasa with Platinum24 Cabs. Booking was easy and service was top-notch.',
        rating: 5,
    },
];


















































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];










const puneLavasaSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Reliable and affordable Pune to Lavasa Cab Service offering private taxis, one-way trips, weekend getaway cabs, and outstation taxi rentals with driver.",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Pune to Lavasa Cab Services",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Pune to Lavasa Taxi"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Lavasa Cab Rental Pune"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Pune to Lavasa One Way Cab"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Lavasa Cab for Weekend Trips"
        }
      }
    ]
  },
  "telephone": "+91-XXXXXXXXXX",
  "serviceType": [
    "Pune to Lavasa Taxi",
    "Lavasa Cab from Pune",
    "Pune Lavasa Taxi Booking",
    "Taxi Service Pune to Lavasa",
    "Lavasa Cab Rental Pune",
    "Pune to Lavasa Taxi Fare",
    "Pune Lavasa Private Taxi",
    "Lavasa Cab Packages Pune",
    "Pune to Lavasa One Way Cab",
    "Lavasa Taxi Charges Pune",
    "Pune to Lavasa Taxi Hire",
    "Lavasa Cab for Weekend Trips Pune",
    "Pune to Lavasa Outstation Taxi",
    "Lavasa Taxi with Driver Pune",
    "Taxi Service Pune to Lavasa"
  ]
};




    return (
        <div>
<Helmet>
  <title>Pune to Lavasa Cab Service | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Reliable and affordable Pune to Lavasa Cab Service offering private taxis, one-way trips, weekend getaway cabs, and outstation taxi rentals with driver."
  />
  <meta
    name="keywords"
    content="Pune to Lavasa Taxi, Lavasa Cab from Pune, Pune Lavasa Taxi Booking, Taxi Service Pune to Lavasa, Lavasa Cab Rental Pune, Pune to Lavasa Taxi Fare, Pune Lavasa Private Taxi, Lavasa Cab Packages Pune, Pune to Lavasa One Way Cab, Lavasa Taxi Charges Pune, Pune to Lavasa Taxi Hire, Lavasa Cab for Weekend Trips Pune, Pune to Lavasa Outstation Taxi, Lavasa Taxi with Driver Pune, Taxi Service Pune to Lavasa"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneLavasaSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/50.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetolavasacabservice;